import { render } from "./VabeneProgrammeList.vue?vue&type=template&id=f633b4c2&ts=true"
import script from "./VabeneProgrammeList.vue?vue&type=script&lang=ts"
export * from "./VabeneProgrammeList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__